import React, { Fragment } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import { Label, Icon } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import Responsive                                                from "react-responsive"


let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
//console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( { product, onChange, list, cart } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize

    let hasCustomVE = false
    if(product.extras){
      hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
    }
    //console.log("PRODUCT ROW: ", product)
    //console.log("shop.delivery[0]",shop.delivery[0])
    /*for (let i = 0; i < shop.delivery[0].positions.length; i++) {
        if(shop.delivery[0].positions[i].article_id === product.article_nr){
            product.deliveryCount = shop.delivery[0].positions[i].count
            product.trueReturnValue = product.trueReturnValue || false
        }
    }*/

  return (
    <Fragment>
      <Responsive minWidth={790}>
        <tr className="bb ProductRowDefReturn">
        <td className="bb ProductRowDefReturn" style={{ fontSize: 12, alignContent: "right", textAlign: "left" }}>{product.article_nr}&nbsp;<strong>{product.desc.short_des}</strong> <br/>
        </td>  
        <td className="bb ProductRowDefReturn" style={{ fontSize: 12, alignContent: "right", textAlign: "left" }}>
          {product.barcode}
        </td>
        <td className="bb ProductRowDefReturn" style={{ fontSize: 12, alignContent: "right", textAlign: "right" }}>
          &nbsp;
        </td>

        {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
        {/*<td></td>*/}
        
        <td className="tr bb ProductRowDefReturn" style={{ fontSize: 12, alignContent: "right", textAlign: "center" }}>
          {product.count-1}
        </td>
        
        {list && <td>
          <div className="fr"><ListActions list={list} product={product}/></div>
        </td>}
        {/*<td className="bb ProductRowDefReturn" style={{ fontSize: 12, alignContent: "right", textAlign: "right" }}>
          <div className="tr fw6">
            {<div><Price>{product.price * (product.count-1)}</Price></div>}
          </div>
        </td>*/}
      </tr>
      </Responsive>
      <Responsive maxWidth={789}>
        <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">Artikel: </td>
          <td  className="bb b--black-20 tr">{product.article_nr}&nbsp;<strong>{product.desc.short_des}</strong></td>
        </tr>
        <tr className={` ProductRowDefReturnMobile step `}>
          <td className="fw7 ">EAN: </td>
          <td  className="bb b--black-20 tr">{product.barcode}</td>
        </tr>
        <tr className={`  ProductRowDefReturnMobile step`}>
          <td className="bb fw7 ProductRowDefReturnMobileLeft ">{translate( "Restanten:" )} </td>
          <td  className="tr b--black-20 bb ProductRowDefReturnMobileRight">{product.count-1}</td>
        </tr>
        {/*<tr className={`  ProductRowDefReturnMobile step `}>
          <td className="bb fw7 ProductRowDefReturnMobileLeft">
          {translate( "UVP:" )}
          </td >
        <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
          <Price>{product.price * (product.count-1)}</Price>
          </td>
      </tr>*/}
      </Responsive>
      </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductRowDefaultReturnReadOnly.js